import StandardDataRenderer, {StandardRenderChildProps} from '../renderers/standard-data-renderer';
import {DataConfig} from '../types';
import {compileTemplate} from '../../lib/simple-template';
import {useMemo, useState} from 'react';
import ErrorMessage from '../../components/error-message';

export function CustomText(props:StandardRenderChildProps) {
    let {data, dataConfig, metadata} = props;
    let [err, setErr] = useState<string>('');

    let formattedData = useMemo(() =>
        data.map(row => metadata.reduce((prev, currMeta) => ({...prev, [currMeta.name]: currMeta.formatSimple(row)}), {}))
    , [data, metadata]);

    let text = useMemo(() => {
        try {
            // Compile and execute template with our simple template engine
            const compiledTemplate = compileTemplate(dataConfig.options.template || '');

            return compiledTemplate({
                d: data,           // Raw data
                f: formattedData   // Formatted data
            });
        } catch (e) {
            if (typeof e === 'string') {
                setErr(e.toUpperCase());
            } else if (e instanceof Error) {
                setErr(e.message);
            }

            return '';
        }
    }, [data, formattedData, dataConfig]);

    return <div>
        {err && <ErrorMessage error={err} />}
        {/* SECURITY: Do NOT use dangerouslySetInnerHTML here - React's auto-escaping prevents XSS */}
        {text}
    </div>;
}

export default function CustomTextRenderer(props: {
    dataConfig: DataConfig
    loadCB?: (promise: Promise<void>) => void
}) {
    return (
        <StandardDataRenderer dataConfig={props.dataConfig} loadCB={props.loadCB}>
            {CustomText}
        </StandardDataRenderer>
    );
}